import React from 'react';
import { Link } from 'react-router-dom';

const PublicFooter: React.FC = () => {
  return (
    <footer className="w-full py-6 mt-auto">
      <div className="flex flex-col items-center gap-2 text-xs text-gray-400 dark:text-gray-500">
        <div className="flex items-center gap-3">
          <Link
            to="/send-data"
            className="hover:text-gray-600 dark:hover:text-gray-300 transition-colors font-medium"
          >
            🌍 Diaspora Top-Up
          </Link>
          <span className="text-gray-300 dark:text-gray-600">•</span>
          <Link
            to="/terms"
            className="hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          >
            Terms &amp; Conditions
          </Link>
          <span className="text-gray-300 dark:text-gray-600">•</span>
          <Link
            to="/privacy"
            className="hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          >
            Privacy Policy
          </Link>
        </div>
        <p>© {new Date().getFullYear()} GHData Market. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default PublicFooter;
